import { api } from "./api";

// Admin-managed product / plan catalog. Backed by Stripe products + prices with
// a Firestore mirror; the backend owns all pricing.

export const listAdminProducts = async () => {
  const { data } = await api.get("/api/catalog/admin");
  return data;
};

export const listPublishedProducts = async (category) => {
  const { data } = await api.get("/api/catalog", { params: category ? { category } : {} });
  return data;
};

// input: { category, name, description, images, prices:[{unitAmount, interval?, label?}],
//          variants, shippingClass, inventory, active, published }
export const createProduct = async (input) => {
  const { data } = await api.post("/api/catalog", input);
  return data;
};

export const updateProduct = async (id, patch) => {
  const { data } = await api.patch(`/api/catalog/${id}`, patch);
  return data;
};

export const archiveProduct = async (id) => {
  const { data } = await api.post(`/api/catalog/${id}/archive`);
  return data;
};
